require('searches/actions/search_actions')

import { changeSearchTab } from 'js/searches/tabs/actions';
import { bindPlayCollection } from '../../play_collection'
import posthog from 'posthog-js';
import { PH_EVENTS } from 'js/posthog_analytics'

SearchActions = LP.module('Searches').SearchActions
LpBoclips   = LP.module('LpBoclips')

class SearchObservers
  constructor: ({@context}) ->
    $('body').on 'click', '.trk-show-resource', @_handleResourceClick
    $('body').on 'click', '.search-result-item.folder-item .panel-resource', @_handleFolderResourceClick
    $('body').on 'click', '.play-collection-btn > a.for-visitor', @_handlePlayBtnClick
    $('body').on 'click', '.search-result-item .btn.trk-goto-resource', @_handleGoToBtnClick
    $(window).on 'popstate', @_handleStateChange
    $('#search-form').on 'submit', @_handleSearchSubmit
    LP.module('Popovers').init()
    @.bindOpenBoclipsModals()
    bindPlayCollection()

  setContext: (@context) =>

  _handleFolderResourceClick: (event) =>
    event.preventDefault()
    event.stopImmediatePropagation()
    $el = $(event.currentTarget)
    if $(event.target).hasClass('trk-show-resource') || $(event.target).parent().hasClass('trk-show-resource')
      if LP.isPhone()
        window.location.href = $(event.target).attr('href') || $(event.target).parent().attr('href')
    else
      $link = $el.find('a.trk-goto-resource')
      window.location.href = $link.attr('href')

  _handleResourceClick: (e) =>
    unless LP.isPhone()
      e.preventDefault()
      $link = $ e.currentTarget
      @context.executeAction(
        SearchActions.showResource,
        url: $link.attr('href'),
        title: $link.attr('title') || $link.closest('.panel-resource').find('.resource-title').contents().filter(-> @nodeType is 3).text(),
        transition: $link.data('transition')
      )

  _handleStateChange: (e) =>
    url = document.location.href
    virtualPageView?(url)
    return if @context.getStore('RouteStore').dispatcherInitiatedStateChange
    action = url.match(/https?:\/\/.*?\/(.*?)(\/|\?|$)/)[1]
    query = url.match(/.*?((\?|$).*)/)[1]
    switch action
      when 'pr', 'teachers', 'wl', 'collections'
        if url.match(/folder_navigation/g)
          window.location.href = url
        else
          @context.executeAction(SearchActions.showResource, url: url, title: document.title, fromBackButton: true)
      when 'search'
        searchTabStoreName = 'SearchTabStore'
        if @context.hasStore(searchTabStoreName)
          prevSearchTabId = @context.getStore('ParamStore').get('search_tab_id')
          searchTabStore = @context.getStore(searchTabStoreName)
          searchTabId = (new URLSearchParams(window.location.search)).get('search_tab_id') || searchTabStore._defaultTabId
          if prevSearchTabId == searchTabId
            @context.executeAction(SearchActions.loadSearch, query: query, fromBackButton: true)
          else
            searchTab = searchTabStore.get(searchTabId)
            @context.executeAction(
              changeSearchTab,
              Object.assign(searchTab, { previousTabId: prevSearchTabId, fromBackButton: true })
            )
        else
          @context.executeAction(SearchActions.loadSearch, query: query, fromBackButton: true)
      else
        window.location.href = url

  _handleSearchSubmit: (e) =>
    return unless ///^#{window.location.pathname}///.test $('#search-form').attr('action')
    e.preventDefault()
    $('.js-search-keywords').typeahead 'hide'
    @context.executeAction(SearchActions.deleteParam, 'concept_ids')
    @context.executeAction(SearchActions.deleteParam, 'keyterm_ids')
    @context.executeAction SearchActions.setParams, params: { keywords: $('.js-search-keywords').val(), kw_and: '', kw_or: '', kw_not: '', kw_phrase: '' }
    @_hideDeviceKeyboard($('.js-search-keywords')) unless LP.config.isDesktop

  # Hide keyboard on mobile devices because it stays open when Enter/Go is tapped
  _hideDeviceKeyboard: (element) =>
    element.attr 'readonly', 'readonly'
    # Force keyboard to hide on input field.
    element.attr 'disabled', 'true'
    setTimeout (->
      element.blur()
      # Remove readonly attribute after keyboard is hidden.
      element.removeAttr 'readonly'
      element.removeAttr 'disabled'
      return
    ), 100

  _handlePlayBtnClick: (e) =>
    e.preventDefault()
    target = e.currentTarget
    return unless target.closest('#search-results')
    target.focus()
    return unless $('#search-layout-group > #thumbnail').hasClass('active')
    panel = target.closest('.panel-resource')
    forceHoverClass = 'panel-resource-force-hover'
    panel.classList.add(forceHoverClass)
    target.addEventListener('blur', -> panel.classList.remove(forceHoverClass))

  _handleGoToBtnClick: (e) =>
    posthog.capture(PH_EVENTS.SITE.GO_TO_RESOURCE)

  bindOpenBoclipsModals: =>
    if !LpBoclips?.LpBoclipsActions? || $('#boclips-videos-section').length == 1 || LP.config.search_tabs_enabled != true
      return
    self = this
    parentClass = 'boclips_media_card'
    $(document).off('click touch touchstart', ".#{parentClass} .boclips_card")
    $(document).on('click touch touchstart',".#{parentClass} .boclips_card", (e) ->
      unless LP.isPhone()
        e.preventDefault()
        $link = $(e.currentTarget);
        data = $link.parents(".#{parentClass}:first").parent().data();
        self.context.executeAction(LpBoclips.LpBoclipsActions.showResource, {
          url: data.url,
          title: data.title,
          transition: data.transition,
          videoUrl: data.videoUrl,
          type: 'boclips_video'
        });
    )

LP.module('Searches').SearchObservers = SearchObservers
